export default "__VITE_ASSET__CvP9HCqv__"